/* Project Import will be here */
import { applyFilterApi } from "../services/products";
import {
    getErrorObject,
    normalizeByGroup,
    mergeMultipleSchemeProducts
} from "../utilities/utils";
/* Project Import will be here */

export const types = {
    RECOMMENDED_PRODUCTS_REQUEST: "Recommended/RECOMMENDED_PRODUCTS_REQUEST",
    RECOMMENDED_PRODUCTS_SUCCESS: "Recommended/RECOMMENDED_PRODUCTS_SUCCESS",
    RECOMMENDED_PRODUCTS_FAILURE: "Recommended/RECOMMENDED_PRODUCTS_FAILURE",
    RECOMMENDED_UPDATE_IS_FAV: "Recommended/RECOMMENDED_UPDATE_IS_FAV"
};

const initialState = {
    groupIds: [],
    group: {},
    isLoading: false,
    ids: [],
    data: {},
    count: null,
    error: null
};

export const recommended = (state = initialState, action) => {
    switch (action.type) {
        case types.RECOMMENDED_PRODUCTS_REQUEST: {
            return {
                ...initialState,
                isLoading: true
            };
        }
        case types.RECOMMENDED_PRODUCTS_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.RECOMMENDED_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case types.RECOMMENDED_UPDATE_IS_FAV:
            let { ProductId, IsFavourite } = action.payload;
            if (ProductId in state.data) {
                return {
                    ...state,
                    data: { ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 } },
                    error: null,
                    isLoading: false
                };
            }
            else {
                return state;
            }
        default:
            return state;
    }
};

export const getRecommendedProducts = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.RECOMMENDED_PRODUCTS_REQUEST });
        try {
            /* Get the scheme product for hot deals */
            const requestObj = {
                NeedRecommended: true,
                Page: 1,
                Sorting: getState().appSettings.defaultProductSorting
            };
            const response = await applyFilterApi(requestObj);

            /* Merge the multi scheme products */
            const recommendedProductList = mergeMultipleSchemeProducts(response.data.Data);

            let payload = normalizeByGroup({
                data: recommendedProductList,
                key: "ProductId",
                groupKey: "GroupId"
            });
            payload.count = recommendedProductList.length;

            dispatch({ type: types.RECOMMENDED_PRODUCTS_SUCCESS, payload });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.RECOMMENDED_PRODUCTS_FAILURE,
                payload: { error: message }
            });
        }
    };
};